<script lang="ts">
  export let handleModel;
  export let model;
  export let selected;
</script>

<li
  class="list-item-base"
  class:list-item-selected={selected === model}
  class:list-item={selected !== model}
  on:click={handleModel(model)}
>
  {model.label || model.name || ""}
</li>

<style lang="postcss">
  .list-item-base {
    height: 45px;
    @apply flex border items-center px-4 mb-2 text-sm cursor-pointer rounded-lg;
  }

  .list-item {
    @apply border-gray-300;
  }

  .list-item-selected {
    @apply transition-colors border-none bg-blue-400 text-white;
  }
</style>
